import React, { useState, useEffect } from "react";
import Navbar from "../features/Navbar"; // Ensure correct path
import Footer from "../components/Footer"; // Ensure correct path

const Video = () => {
  const channelId = "UCEDY0y5DWKikCYzdKJILkiw"; // Your YouTube Channel ID
  const [isLive, setIsLive] = useState(true);

  useEffect(() => {
    // Simulate a check for live stream availability
    const checkLiveStatus = () => {
      const testVideo = document.createElement("iframe");
      testVideo.src = `https://www.youtube.com/embed/live_stream?channel=${channelId}`;
      testVideo.onload = () => setIsLive(true); // If it loads, assume live
      testVideo.onerror = () => setIsLive(false); // If error, assume not live
    };

    checkLiveStatus();

    // Retry every 30 seconds (optional)
    const interval = setInterval(checkLiveStatus, 30000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className="w-full h-screen flex flex-col">
      {/* Header / Navbar */}
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col justify-center items-center mt-8 mx-[16px] md:mx-[30px] lg:mx-[120px]">
        <h1 className="text-3xl font-bold mb-6 text-center">Watch Live Video</h1>

        {/* Video Player or Fallback Message */}
        <div className="video-player w-full flex-1 mb-6">
          {isLive ? (
            <div className="relative w-full h-[600px] shadow-lg border border-gray-300 rounded-xl overflow-hidden">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/live_stream?channel=${channelId}&autoplay=1`}
                title="YouTube Live Stream"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <div className="flex flex-col items-center bg-gray-100 p-6 rounded-xl shadow-md w-full h-[600px] justify-center">
              <p className="text-2xl text-black font-semibold text-center">
                Be patient with us, we will be live soon! 🙏
              </p>
              <p className="text-lg text-black mt-4">
                Stay tuned and check back later for our live stream.
              </p>
              <img
                src="https://via.placeholder.com/600x300?text=Live+Stream+Coming+Soon"
                alt="Live Stream Coming Soon"
                className="mt-6 w-[500px] rounded-lg shadow-lg"
              />
            </div>
          )}
        </div>

        {/* Video Description */}
        <div className="description w-full text-center px-4">
          <p className="text-2xl mb-8">
            Join us for our live Sunday service where we fellowship with God through our Lord Jesus Christ. 
            Don't miss out on this enlightening experience!
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Video;
